import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown, FaEnvelope, FaPhone } from 'react-icons/fa';

import '../assets/css/Navbar.css';
import { API_BASE_URL } from '../config';

// Import logo
import logo from '../assets/images/logo.png';

const Navbar = () => {
  const [officeDropdown, setOfficeDropdown] = useState(false);
  const [chairsDropdown, setChairsDropdown] = useState(false);
  const [storageDropdown, setStorageDropdown] = useState(false);
  const [sofaDropdown, setSofaDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [officeSubcategories, setOfficeSubcategories] = useState([]);
  const [chairSubcategories, setChairSubcategories] = useState([]);
  const [storageSubcategories, setStorageSubcategories] = useState([]);
  const [sofaSubcategories, setSofaSubcategories] = useState([]);
  const [acousticDropdown, setAcousticDropdown] = useState(false);
  const [acousticSubcategories, setAcousticSubcategories] = useState([]);
  const [wallCladdingDropdown, setWallCladdingDropdown] = useState(false);
  const [wallCladdingSubcategories, setWallCladdingSubcategories] = useState([]);
  
  // Add mobile dropdown states
  const [mobileDropdowns, setMobileDropdowns] = useState({
    office: false,
    chairs: false,
    storage: false,
    sofa: false,
    acoustic: false,
    wallCladding: false
  });

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Clean up the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Set fallback subcategories immediately
    setOfficeSubcategories([
      { id: 1, name: 'Executive Desks' },
      { id: 2, name: 'Conference Tables' },
      { id: 3, name: 'Workstations' },
      { id: 4, name: 'Reception Desks' }
    ]);
    
    setChairSubcategories([
      { id: 5, name: 'Executive Chairs' },
      { id: 6, name: 'Task Chairs' },
      { id: 7, name: 'Conference Chairs' },
      { id: 8, name: 'Reception Chairs' }
    ]);
    
    setStorageSubcategories([
      { id: 9, name: 'Filing Cabinets' },
      { id: 10, name: 'Bookcases' },
      { id: 11, name: 'Storage Units' },
      { id: 12, name: 'Lockers' }
    ]);
    
    setSofaSubcategories([
      { id: 13, name: 'Office Sofas' },
      { id: 14, name: 'Lounge Chairs' },
      { id: 15, name: 'Waiting Area Seating' },
      { id: 16, name: 'Reception Sofas' }
    ]);

    setAcousticSubcategories([
      { id: 17, name: 'Acoustic Panels' },
      { id: 18, name: 'Sound Barriers' },
      { id: 19, name: 'Noise Control' },
      { id: 20, name: 'Privacy Screens' }
    ]);

    setWallCladdingSubcategories([
      { id: 21, name: 'Wood Cladding' },
      { id: 22, name: 'Metal Cladding' },
      { id: 23, name: 'Stone Cladding' },
      { id: 24, name: 'Composite Cladding' }
    ]);

    // Fetch subcategories for all categories
    const fetchSubcategories = async () => {
      try {
        console.log('🔍 Navbar - Fetching subcategories...');
        
        // Fetch office furniture subcategories (category ID 1)
        const officeResponse = await fetch(`${API_BASE_URL}subcategories.php?category_id=1`);
        console.log('Office subcategories response:', officeResponse.status);
        if (officeResponse.ok) {
          const officeData = await officeResponse.json();
          console.log('Office subcategories data:', officeData);
          if (officeData.success) {
            setOfficeSubcategories(officeData.subcategories);
          }
        }

        // Fetch office chairs subcategories (category ID 2)
        const chairsResponse = await fetch(`${API_BASE_URL}subcategories.php?category_id=2`);
        console.log('Chairs subcategories response:', chairsResponse.status);
        if (chairsResponse.ok) {
          const chairsData = await chairsResponse.json();
          console.log('Chairs subcategories data:', chairsData);
          if (chairsData.success) {
            setChairSubcategories(chairsData.subcategories);
          }
        }

        // Fetch storage solutions subcategories (category ID 3)
        const storageResponse = await fetch(`${API_BASE_URL}subcategories.php?category_id=3`);
        console.log('Storage subcategories response:', storageResponse.status);
        if (storageResponse.ok) {
          const storageData = await storageResponse.json();
          console.log('Storage subcategories data:', storageData);
          if (storageData.success) {
            setStorageSubcategories(storageData.subcategories);
          }
        }

        // Fetch sofa in lounge subcategories (category ID 4)
        const sofaResponse = await fetch(`${API_BASE_URL}subcategories.php?category_id=4`);
        console.log('Sofa subcategories response:', sofaResponse.status);
        if (sofaResponse.ok) {
          const sofaData = await sofaResponse.json();
          console.log('Sofa subcategories data:', sofaData);
          if (sofaData.success) {
            setSofaSubcategories(sofaData.subcategories);
          }
        }

        // Fetch acoustic solutions subcategories (category ID 5)
        const acousticResponse = await fetch(`${API_BASE_URL}subcategories.php?category_id=5`);
        console.log('Acoustic subcategories response:', acousticResponse.status);
        if (acousticResponse.ok) {
          const acousticData = await acousticResponse.json();
          console.log('Acoustic subcategories data:', acousticData);
          if (acousticData.success) {
            setAcousticSubcategories(acousticData.subcategories);
           
          }
        }

        // Fetch wall cladding subcategories (category ID 6)
        const wallCladdingResponse = await fetch(`${API_BASE_URL}subcategories.php?category_id=6`);
        console.log('Wall Cladding subcategories response:', wallCladdingResponse.status);
        if (wallCladdingResponse.ok) {
          const wallCladdingData = await wallCladdingResponse.json();
          console.log('Wall Cladding subcategories data:', wallCladdingData);
          if (wallCladdingData.success) {
            setWallCladdingSubcategories(wallCladdingData.subcategories);
         
          }
        }
      } catch (error) {
        console.error('Error fetching subcategories:', error);
        // Fallback data is already set above
      }
    };

    fetchSubcategories();
  }, []);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const toggleMobileDropdown = (dropdownName) => {
    setMobileDropdowns(prev => {
      // Create a new state where all dropdowns are closed
      const allClosed = {
        office: false,
        chairs: false,
        storage: false,
        sofa: false,
        acoustic: false,
        wallCladding: false
      };
      
      // If the clicked dropdown is currently open, close it
      // If it's closed, open it (all others will be closed due to allClosed)
      return {
        ...allClosed,
        [dropdownName]: !prev[dropdownName]
      };
    });
  };

  const handleDropdownItemClick = () => {
    // Close mobile menu and all mobile dropdowns when dropdown item is clicked
    setMobileMenuOpen(false);
    setMobileDropdowns({
      office: false,
      chairs: false,
      storage: false,
      sofa: false,
      acoustic: false,
      wallCladding: false
    });
  };

  const handleDesktopDropdownItemClick = () => {
    // Close all desktop dropdowns when dropdown item is clicked
    setOfficeDropdown(false);
    setChairsDropdown(false);
    setStorageDropdown(false);
    setSofaDropdown(false);
    setAcousticDropdown(false);
    setWallCladdingDropdown(false);
  };

  const handleAllDropdownItemClick = () => {
    // Close both mobile and desktop dropdowns
    handleDropdownItemClick();
    handleDesktopDropdownItemClick();
  };
  
  return (
    <nav className={`navbar ${isScrolled ? 'navbar-fixed' : ''}`}>
      <div className="navbar-top">
        <div className="logo-container">
          <Link to="/">
            <img src={logo} alt="Design Craft Logo" className="logo" />
          </Link>
        </div>
        <div className={`navbar-contact-info ${mobileMenuOpen ? 'hidden-mobile' : ''}`}>
          {/* <a href="mailto:sales@designcraft.ae" className="contact-link">
            <FaEnvelope /> sales@designcraft.ae
          </a> */}
          <a href="mailto:sales@designcraft.ae" className="contact-link">
            <FaEnvelope /> sales@designcraft.ae
          </a>
          <a href="tel:+971501900982" className="contact-link">
            <FaPhone /> +971 50 1900 982
          </a>
        </div>
      </div>
      
      <div className="navbar-bottom">
        <button 
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
        
        <ul className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
          <li 
            className="dropdown-container"
            onMouseEnter={() => setOfficeDropdown(true)}
            onMouseLeave={() => setOfficeDropdown(false)}
          >
            <span 
              className="nav-link" 
              onClick={() => {
                if (window.innerWidth <= 768) {
                  toggleMobileDropdown('office');
                }
              }}
            >
              OFFICE FURNITURE <FaChevronDown />
            </span>
            {((window.innerWidth <= 768 && mobileDropdowns.office) || (window.innerWidth > 768 && officeDropdown)) && (
              <div className="dropdown-menu">
                {officeSubcategories.map(subcategory => (
                  <Link 
                    key={subcategory.id} 
                    to={`/office-furniture/${subcategory.name.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={handleAllDropdownItemClick}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            )}
          </li>
          
          <li 
            className="dropdown-container"
            onMouseEnter={() => setChairsDropdown(true)}
            onMouseLeave={() => setChairsDropdown(false)}
          >
            <span 
              className="nav-link" 
              onClick={() => {
                if (window.innerWidth <= 768) {
                  toggleMobileDropdown('chairs');
                }
              }}
            >
              OFFICE CHAIRS <FaChevronDown />
            </span>
            {((window.innerWidth <= 768 && mobileDropdowns.chairs) || (window.innerWidth > 768 && chairsDropdown)) && (
              <div className="dropdown-menu">
                {chairSubcategories.map(subcategory => (
                  <Link 
                    key={subcategory.id} 
                    to={`/office-chairs/${subcategory.name.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={handleAllDropdownItemClick}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            )}
          </li>
          
          <li 
            className="dropdown-container"
            onMouseEnter={() => setStorageDropdown(true)}
            onMouseLeave={() => setStorageDropdown(false)}
          >
            <span 
              className="nav-link" 
              onClick={() => {
                if (window.innerWidth <= 768) {
                  toggleMobileDropdown('storage');
                }
              }}
            >
              STORAGE SOLUTIONS <FaChevronDown />
            </span>
            {((window.innerWidth <= 768 && mobileDropdowns.storage) || (window.innerWidth > 768 && storageDropdown)) && (
              <div className="dropdown-menu">
                {storageSubcategories.map(subcategory => (
                  <Link 
                    key={subcategory.id} 
                    to={`/storage-solutions/${subcategory.name.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={handleAllDropdownItemClick}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            )}
          </li>
          

          <li 
            className="dropdown-container"
            onMouseEnter={() => setSofaDropdown(true)}
            onMouseLeave={() => setSofaDropdown(false)}
          >
            <span 
              className="nav-link" 
              onClick={() => {
                if (window.innerWidth <= 768) {
                  toggleMobileDropdown('sofa');
                }
              }}
            >
              SOFA <FaChevronDown />
            </span>
            {((window.innerWidth <= 768 && mobileDropdowns.sofa) || (window.innerWidth > 768 && sofaDropdown)) && (
              <div className="dropdown-menu">
                {sofaSubcategories.map(subcategory => (
                  <Link 
                    key={subcategory.id} 
                    to={`/sofa-lounges/${subcategory.name.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={handleAllDropdownItemClick}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            )}
          </li>

          <li 
            className="dropdown-container"
            onMouseEnter={() => setAcousticDropdown(true)}
            onMouseLeave={() => setAcousticDropdown(false)}
          >
            <span 
              className="nav-link" 
              onClick={() => {
                if (window.innerWidth <= 768) {
                  toggleMobileDropdown('acoustic');
                }
              }}
            >
            ACOUSTIC SOLUTIONS <FaChevronDown />
            </span>
            {((window.innerWidth <= 768 && mobileDropdowns.acoustic) || (window.innerWidth > 768 && acousticDropdown)) && (
              <div className="dropdown-menu">
                {acousticSubcategories.map(subcategory => (
                  <Link 
                    key={subcategory.id} 
                    to={`/acoustic-solutions/${subcategory.name.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={handleAllDropdownItemClick}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            )}
          </li>



         
          <li 
            className="dropdown-container"
            onMouseEnter={() => setWallCladdingDropdown(true)}
            onMouseLeave={() => setWallCladdingDropdown(false)}
          >
            <span 
              className="nav-link" 
              onClick={() => {
                if (window.innerWidth <= 768) {
                  toggleMobileDropdown('wallCladding');
                }
              }}
            >
              WALL CLADING <FaChevronDown />
            </span>
            {((window.innerWidth <= 768 && mobileDropdowns.wallCladding) || (window.innerWidth > 768 && wallCladdingDropdown)) && (
              <div className="dropdown-menu">
                {wallCladdingSubcategories.map(subcategory => (
                  <Link 
                    key={subcategory.id} 
                    to={`/wall-cladding/${subcategory.name.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={handleAllDropdownItemClick}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            )}
          </li>
          
          
          {/* <li 
            className="dropdown-container"
            onMouseEnter={() => setSolutionsDropdown(true)}
            onMouseLeave={() => setSolutionsDropdown(false)}
          >
            <Link to="/solutions" className="nav-link">
              SOLUTIONS <FaAngleDown />
            </Link>
            {solutionsDropdown && (
              <div className="dropdown-menu">
                <Link to="/office-planning">Office Planning</Link>
                <Link to="/space-optimization">Space Optimization</Link>
                <Link to="/ergonomic-solutions">Ergonomic Solutions</Link>
              </div>
            )}
          </li> */}

          <li className="nav-item">
            <Link to="/case-study" className="nav-link" onClick={closeMobileMenu}>PROJECTS</Link>
          </li>
          
          
          
          <li className="nav-item">
            <Link to="/design-fitout" className="nav-link" onClick={closeMobileMenu}>FITOUT</Link>
          </li>
          
          
          
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={closeMobileMenu}>CONTACT</Link>
          </li>
        </ul>
        
        {/* <div className="login-button">
          <Link to="/login" className="login-link">LOGIN</Link>
        </div> */}
      </div>
    </nav>
  );
};

export default Navbar; 